module.exports = __webpack_public_path__ + "img/appAsset-brand--facturapi.d3541652.svg";